import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex)

export const store = new Vuex.Store({
    state: {
        token: localStorage.getItem("token"),
        northCapital: {
            accountId: null,
            partyId: null,
            entityId: null,
            linkId: null,
        },
        steps: {
            auth: {
                preAuthenticated: false,
                firstName: null,
                lastName: null,
                phone: null,
                email: null,
                password: null,
                completed: false,
                finished: false,
            },
            basic: {
                accreditedInvestor: "Not Accredited",
                yearlyInvestment: null,
                country: "United States",
                accountType: "Individual",
                otherAccountType: "Entity",
                otherAccountRelation: "Owner",
                entity: {
                    type: "LLC",
                    name: "",
                    ein: "",
                    address1: "",
                    address2: "",
                    city: "",
                    state: "",
                    zip: "",
                    email: "",
                    phone: "",
                },
                secondary: {
                    firstName: null,
                    lastName: null,
                    ssn: null,
                    birthday: null,
                    address1: null,
                    address2: null,
                    city: null,
                    state: null,
                    zip: null,
                    relation: "Member",
                },
                completed: false,
                finished: false,
                changed: false,
            },
            contact: {
                address1: null,
                address2: null,
                city: null,
                state: "",
                zip: null,
                ssn: null,
                birthday: null,
                completed: false,
                finished: false,
                changed: false,
            },
            kyc: {
                required: false,
                type: null,
                file: null,
                completed: false,
                finished: false,
            },
            investment: {
                initialAmount: null,
                autoInvestment: {
                    frequency: "Monthly",
                    startDay: null,
                    amount: 100,
                    otherAmount: 2500,
                },
                completed: false,
                finished: false,
            },
            bankAccount: {
                type: "manual",
                manual: {
                    accountName: null,
                    name: null,
                    type: "Checking",
                    routingNumber: null,
                    accountNumber: null,
                },
                completed: false,
                finished: false,
            },
            agreements: {
                dividendReinvestment: "reinvested",
                acknowledgementPrivacy: false,
                acknowledgementInvestmentDisclosure: false,
                completed: false,
                finished: false,
            },
            review: {
                finished: false,
            },
            // subscription: {
            //     finished: false,
            // },
        },
    },
    mutations: {
        logoutUser(state) {
            state.token = null;
            state.steps.auth.preAuthenticated = false;
            state.steps.auth.firstName = null;
            state.steps.auth.lastName = null;
            state.steps.auth.phone = null;
            state.steps.auth.email = null;
            state.steps.auth.password = null;
            state.steps.auth.completed = false;
            state.steps.contact.state = "";
            localStorage.removeItem("token");
        },
        updateAuth(state, data) {
            state.token = data.token;
            state.steps.auth.firstName = data.firstName;
            state.steps.auth.lastName = data.lastName;
            state.steps.auth.phone = data.phone;
            state.steps.auth.email = data.email;
            state.steps.auth.password = data.password;
            state.steps.auth.completed = true;
            state.steps.auth.finished = true;
            state.steps.auth.completed = true;
            localStorage.setItem("token", data.token);
            window.Intercom('update', {"name": data.firstName + " " + data.lastName, "email": data.email, "user_id": data.id});
        },
        updateBasic(state, data) {
            state.steps.basic.accreditedInvestor = data.accreditedInvestor;
            state.steps.basic.country = data.country;
            state.steps.basic.accountType = data.accountType;
            state.steps.basic.otherAccountType = data.otherAccountType;
            state.steps.basic.otherAccountRelation = data.otherAccountRelation;
            state.steps.basic.entity = data.entity;
            state.steps.basic.secondary = data.secondary;
            if(data.country && data.accountType && data.otherAccountType && data.accreditedInvestor) {
                state.steps.basic.completed = true;
            }
        },
        basicChanged(state, status) {
            state.steps.basic.changed = status;
        },
        updateContact(state, data) {
            state.steps.contact.address1 = data.address1;
            state.steps.contact.address2 = data.address2;
            state.steps.contact.city = data.city;
            state.steps.contact.state = data.state;
            state.steps.contact.zip = data.zip;
            state.steps.contact.ssn = data.ssn;
            state.steps.contact.birthday = data.birthday;
        },
        contactChanged(state, status) {
            state.steps.contact.changed = status;
        },
        updateKYC(state, data) {
            state.steps.kyc.type = data.type;
            state.steps.kyc.file = data.file;
        },
        updateInvestment(state, data) {
            state.steps.investment.initialAmount = data.initialAmount;
            state.steps.investment.autoInvestment.frequency = data.autoInvestment.frequency;
            state.steps.investment.autoInvestment.startDay = data.autoInvestment.startDay;
            state.steps.investment.autoInvestment.amount = data.autoInvestment.amount;
            state.steps.investment.autoInvestment.otherAmount = data.autoInvestment.otherAmount;
        },
        updateBankAccount(state, data) {
            state.steps.bankAccount.type = data.type;
            state.steps.bankAccount.manual.accountName = data.manual.accountName;
            state.steps.bankAccount.manual.name = data.manual.name;
            state.steps.bankAccount.manual.type = data.manual.type;
            state.steps.bankAccount.manual.routingNumber = data.manual.routingNumber;
            state.steps.bankAccount.manual.accountNumber = data.manual.accountNumber;
        },
        updateAgreements(state, data) {
            state.steps.agreements.dividendReinvestment = data.dividendReinvestment;
            state.steps.agreements.acknowledgementPrivacy = data.acknowledgementPrivacy;
            state.steps.agreements.acknowledgementInvestmentDisclosure = data.acknowledgementInvestmentDisclosure;
            if(data.dividendReinvestment && data.acknowledgementPrivacy && data.acknowledgementInvestmentDisclosure) {
                state.steps.agreements.completed = true;
            }
        },
        updateAll(state, data) {
            state.steps.auth.firstName = data.name.split(" ")[0];
            state.steps.auth.lastName = data.name.split(" ")[1];
            state.steps.auth.phone = data.phone;
            state.steps.auth.email = data.email;
            state.steps.auth.completed = true;
            state.steps.auth.finished = true;
            window.Intercom('update', {"name": data.name, "email": data.email, "user_id": data.id});

            if(data.account_id && data.account) {
                state.northCapital.accountId = data.account_id;
                // Basic
                state.steps.basic.accreditedInvestor = data.account.accreditedStatus;
                state.steps.basic.country = data.account.country;
                state.steps.basic.accountType = data.account.accountType !== 'Individual' ? 'Other' : 'Individual';
                state.steps.basic.otherAccountType = (data.account.accountType === 'Individual' ? null : data.account.accountType);
                state.steps.basic.completed = true;
                state.steps.basic.finished = true;
                // Contact
                state.steps.contact.address1 = data.account.address1;
                state.steps.contact.address2 = data.account.address2;
                state.steps.contact.city = data.account.city;
                state.steps.contact.state = data.account.state;
                state.steps.contact.zip = data.account.zip;
                state.steps.contact.ssn = data.account.taxID;
                state.steps.contact.completed = true;
                state.steps.contact.finished = true;
            }
            if(data.party_id && data.party) {
                state.northCapital.partyId = data.party_id;
                state.steps.contact.birthday = data.party.birthday;
                state.steps.kyc.required = ((data.party.kycStatus === 'Disapproved' || data.party.amlStatus === 'Disapproved') && !data.kyc_document_uploaded);
            }
            if(data.entity_id && data.entity) {
                state.northCapital.entityId = data.entity_id;
                state.steps.basic.entity.type = data.entity.entityType;
                state.steps.basic.entity.name = data.entity.entityName;
                state.steps.basic.entity.ein = data.entity.ein;
                state.steps.basic.entity.address1 = data.entity.address1;
                state.steps.basic.entity.address2 = data.entity.address2;
                state.steps.basic.entity.city = data.entity.city;
                state.steps.basic.entity.state = data.entity.state;
                state.steps.basic.entity.zip = data.entity.zip;
                state.steps.basic.entity.email = data.entity.emailAddress;
                state.steps.basic.entity.phone = data.entity.phone;
            }
            if(data.account && ['IRA', 'SepIRA', 'ROTH'].includes(data.account.accountType)) {
                state.steps.basic.entity.name = data.account.accountName;
                state.steps.basic.entity.ein = data.account.taxID;
            }
            if(data.link_id && data.link) {
                state.northCapital.linkId = data.link_id;
                state.steps.basic.otherAccountRelation = data.link.linkType;
            }
            if(data.investment)  {
                state.steps.investment.initialAmount = data.investment.amount;
                state.steps.investment.autoInvestment.frequency = data.auto_investment_period;
                state.steps.investment.autoInvestment.startDay = data.auto_investment_start_day;
                state.steps.investment.autoInvestment.amount = (data.auto_investment_amount !== 100 && data.auto_investment_amount !== 250 && data.auto_investment_amount !== 500 && data.auto_investment_amount !== 1000 && data.auto_investment_amount !== 1500 ? 'Other' : data.auto_investment_amount);
                state.steps.investment.autoInvestment.otherAmount = (state.steps.investment.autoInvestment.amount === 'Other' ? data.auto_investment_amount : null);
                state.steps.investment.completed = true;
                state.steps.investment.finished = true;
            }
            if(data.bank_account_connected && data.bank) {
                state.steps.bankAccount.manual.accountName = data.bank.name;
                state.steps.bankAccount.manual.name = data.bank.nickName ? data.bank.nickName.replace(data.bank.name + " - ", "") : null;
                state.steps.bankAccount.manual.type = data.bank.type;
                state.steps.bankAccount.manual.accountNumber = data.bank.accountNumber;
                state.steps.bankAccount.manual.routingNumber = data.bank.routingNumber;
                state.steps.bankAccount.completed = true;
                state.steps.bankAccount.finished = true;
            }
            if(data.dividend_reinvestment) {
                state.steps.agreements.dividendReinvestment = data.dividend_reinvestment;
                state.steps.agreements.acknowledgementPrivacy = true;
                state.steps.agreements.acknowledgementInvestmentDisclosure = true;
                state.steps.agreements.completed = true;
                state.steps.agreements.finished = true;
            }
            if(data.verified) {
                state.steps.review.finished = true;
            }
            // if(data.trade && data.trade.eSignStatus === 'SIGNED') {
            //     state.steps.subscription.finished = true;
            // }
        },
        resetAll(state) {
            // Reset NorthCapital
            state.northCapital.accountId = null;
            state.northCapital.partyId = null;
            state.northCapital.entityId = null;
            state.northCapital.linkId = null;

            // Update Auth
            state.steps.auth.firstName = null;
            state.steps.auth.lastName = null;
            state.steps.auth.email = null;
            state.steps.auth.password = null;
            state.steps.auth.phone = null;
            state.steps.auth.completed = false;
            state.steps.auth.finished = false;

            // Update Basic
            state.steps.basic.accreditedInvestor = "Not Accredited";
            state.steps.basic.country = "United States";
            state.steps.basic.accountType = "Individual";
            state.steps.basic.otherAccountType = "Entity";
            state.steps.basic.otherAccountRelation = "Owner";
            state.steps.basic.entity.type = "LLC";
            state.steps.basic.entity.name = "";
            state.steps.basic.entity.ein = "";
            state.steps.basic.entity.address1 = "";
            state.steps.basic.entity.address2 = "";
            state.steps.basic.entity.city = "";
            state.steps.basic.entity.state = "";
            state.steps.basic.entity.zip = "";
            state.steps.basic.entity.email = "";
            state.steps.basic.entity.phone = "";
            state.steps.basic.completed = false;
            state.steps.basic.finished = false;
            state.steps.basic.changed = false;

            // Update Contact
            state.steps.contact.address1 = null;
            state.steps.contact.address2 = null;
            state.steps.contact.city = null;
            state.steps.contact.state = "";
            state.steps.contact.zip = null;
            state.steps.contact.ssn = null;
            state.steps.contact.birthday = null;
            state.steps.contact.completed = false;
            state.steps.contact.finished = false;
            state.steps.contact.changed = false;

            // Update KYC
            state.steps.kyc.required = false;
            state.steps.kyc.type = null;
            state.steps.kyc.file = null;
            state.steps.kyc.completed = false;
            state.steps.kyc.finished = false;

            // Investment
            state.steps.investment.initialAmount = null;
            state.steps.investment.autoInvestment.frequency = "Disabled";
            state.steps.investment.autoInvestment.startDay = 1;
            state.steps.investment.autoInvestment.amount = 100;
            state.steps.investment.autoInvestment.otherAmount = null;
            state.steps.investment.completed = false;
            state.steps.investment.finished = false;

            // Bank
            state.steps.bankAccount.type = "manual";
            state.steps.bankAccount.manual.accountName = null;
            state.steps.bankAccount.manual.name = null;
            state.steps.bankAccount.manual.type = "Checking";
            state.steps.bankAccount.manual.routingNumber = null;
            state.steps.bankAccount.manual.accountNumber = null;
            state.steps.bankAccount.completed = false;
            state.steps.bankAccount.finished = false;

            // Agreements
            state.steps.agreements.dividendReinvestment = "reinvested";
            state.steps.agreements.acknowledgementPrivacy = false;
            state.steps.agreements.acknowledgementInvestmentDisclosure = false;
            state.steps.agreements.completed = false;
            state.steps.agreements.finished = false;

            // Review
            state.steps.review.finished = false;

            // Subscription
            // state.steps.subscription.finished = false;

        },
        finishAuth(state) {
            state.steps.auth.finished = true;
        },
        finishBasic(state) {
            state.steps.basic.finished = true;
        },
        finishContact(state) {
            state.steps.contact.completed = true;
            state.steps.contact.finished = true;
        },
        finishInvestments(state) {
            state.steps.investment.completed = true;
            state.steps.investment.finished = true;
        },
        finishBank(state) {
            state.steps.bankAccount.completed = true;
            state.steps.bankAccount.finished = true;
        },
        finishAgreements(state) {
            state.steps.agreements.finished = true;
        },
        finishReview(state) {
            state.steps.review.finished = true;
        },
        // finishSubscription(state) {
        //     state.steps.subscription.finished = true;
        // },
        finishKYC(state) {
            state.steps.kyc.completed = true;
            state.steps.kyc.finished = true;
        },
        requireKYC(state) {
            state.steps.kyc.required = true;
        },
        updateNorthCapital(state, data) {
            state.northCapital.accountId = data.account;
            state.northCapital.party = data.party;
            state.northCapital.linkId = data.link;
        },
        setPreAuthenticated(state) {
            state.steps.auth.preAuthenticated = true;
        },
    },
    getters: {
        token: state => state.token,
        steps: state => {
            return state.steps;
        },
        auth: state => {
            return state.steps.auth;
        },
        basic: state => {
            return state.steps.basic;
        },
        contact: state => {
            return state.steps.contact;
        },
        kyc: state => {
            return state.steps.kyc;
        },
        investment: state => {
            return state.steps.investment;
        },
        bankAccount: state => {
            return state.steps.bankAccount;
        },
        agreements: state => {
            return state.steps.agreements;
        },
        review: state => {
            return state.steps.review;
        },
        // subscription: state => {
        //     return state.steps.subscription;
        // },
        northCapital: state => state.northCapital,
    },
})